

























































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { BookingEvent } from '@bookings/interfaces/booking-event';
import moment from 'moment';
import { CenterSetting } from '@core/interfaces/center-setting';
import ModulesHelper from '@core/services/modules.helper';
import { bookingEventFields } from '@/config/booking_event';
import Select from '@shared/components/forms/inputs/select/select.vue';

@Component({
  name: 'bpc-booking-event-cancel-modal',
  components: {
    'bpc-select': Select,
  },
})
export default class CancelBookingEventModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String }) readonly modalId: string;
  @Prop({
    type: Object,
  })
  readonly entity: BookingEvent;
  @Prop({ type: Array, default: null }) readonly selectionBookingEvent: BookingEvent[];
  @Prop({ type: Boolean, default: false }) readonly isProfileView: boolean;
  @Prop({ type: Boolean, default: false }) readonly bookingRepetitive: boolean;

  //const :
  readonly DEFAULT_REPETITIVE_ACTION_OPTION_SELECTED = 'only_this';

  //variable
  public cancelReasonOptionSelected: string = '';
  public cancelReasonOptionDescriptionSelected: string = '';
  public confirmUpdateOrderOptionSelected: string = 'update';
  public notifyByEmailOptionSelected: boolean = true;
  public repetitiveActionOptionSelected: string = this.DEFAULT_REPETITIVE_ACTION_OPTION_SELECTED;
  public cancelingBookingEvents: boolean = false;
  public permissionEntityNameToUse = 'bookings';
  public pluralEntityName = 'booking-events';

  public repetitiveActionOptions: Record<string, any> = [
    {
      text: this.$t('global.modals.update-booking-event.multiple.action_option.options.only'),
      value: 'only_this',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.next_same_events',
      ),
      value: 'next_same',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.all_same_events',
      ),
      value: 'all_same',
    },
    {
      text: this.$t('global.modals.update-booking-event.multiple.action_option.options.all_events'),
      value: 'cancel_all',
    },
  ];

  public confirmUpdateOrderOptions: object[] = [
    {
      text: this.$t('global.modals.cancel-booking-event.multiple.orders.options.no_update'),
      value: 'no_update',
    },
    {
      text: this.$t('global.modals.cancel-booking-event.multiple.orders.options.update'),
      value: 'update',
    },
  ];

  public notifyByEmailOptions: object[] = [
    {
      text: this.$t('global.yes'),
      value: true,
    },
    {
      text: this.$t('global.no'),
      value: false,
    },
  ];

  key: number = 0;

  get cancelReasonDescriptionOptionsLabel() {
    return this.$t('bookings.bookings.reason_description');
  }

  get alertVariant() {
    if (!this.entity) {
      return 'primary';
    }
    if (this.confirmUpdateOrderOptionSelected === 'no_update') {
      return 'warning';
    } else {
      return 'danger';
    }
  }

  get fieldsConfig() {
    return bookingEventFields;
  }

  get cancelOrderMessageLabel() {
    if (!this.entity) {
      return this.$t('global.alerts.orders_bulk_cancelled');
    }
    if (this.confirmUpdateOrderOptionSelected === 'no_update') {
      return this.$t('global.alerts.order_remained_due');
    } else {
      return this.$t('global.alerts.order_cancelled');
    }
  }

  public get orderOptionsLabel() {
    return this.$t('global.modals.cancel-booking-event.multiple.orders.label');
  }

  public get communicationActivated() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);
  }

  public get accountingActivated() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACCOUNTING_MODULE_NAME);
  }

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  get cancelled_unpaid_booking_remain_due(): boolean {
    return this.centerSetting?.cancelled_unpaid_booking_remain_due;
  }

  get cancelled_paid_booking_generate_refund(): boolean {
    return this.centerSetting?.cancelled_paid_booking_generate_refund;
  }

  public get profileCanChangeOrders() {
    return this.$authorizationService.hasPermission('force_price_update_booking');
  }

  get isCanceling() {
    return this.cancelingBookingEvents || this.isHandlingClick;
  }

  public resetModal() {
    this.cancelReasonOptionSelected = '';
    this.cancelReasonOptionDescriptionSelected = '';
    this.repetitiveActionOptionSelected = this.DEFAULT_REPETITIVE_ACTION_OPTION_SELECTED;
    if (this.$modulesService.hasModuleActivated(ModulesHelper.VIRTUAL_WALLET_MODULE_NAME)) {
      this.confirmUpdateOrderOptions = this.confirmUpdateOrderOptions.filter(
        (option: any) => option.value !== 'update_and_refund',
      );
      if (
        (this.entity?.contact?.contact_individual_id && this.entity?.paid_amount > 0) ||
        this.selectionBookingEvent?.length > 0
      ) {
        this.confirmUpdateOrderOptions.push({
          text: this.$t(
            'global.modals.cancel-booking-event.multiple.orders.options.update_and_refund',
          ),
          value: 'update_and_refund',
        });
      }
    }
  }

  public setModal() {
    if (this.entity?.orders_status === 'paid') {
      this.confirmUpdateOrderOptionSelected = this.cancelled_paid_booking_generate_refund
        ? 'update'
        : 'no_update';
    } else {
      this.confirmUpdateOrderOptionSelected = this.cancelled_unpaid_booking_remain_due
        ? 'no_update'
        : 'update';
    }
  }

  openModal() {
    this.$bvModal.show(this.modalId);
    this.resetModal();
    this.setModal();
  }

  // implementation of the handleConfirmCancelClick method to avoid double click
  private isHandlingClick: boolean = false;

  handleConfirmCancelClick() {
    // If we're already processing a click, ignore completely
    if (this.isHandlingClick || this.cancelingBookingEvents) {
      return;
    }

    // Set both flags immediately
    this.isHandlingClick = true;
    this.cancelingBookingEvents = true;

    const action = this.entity
      ? this.onConfirmCancelEvent()
      : this.onConfirmCancelEventCollection();

    Promise.resolve(action).finally(() => {
      this.cancelingBookingEvents = false;

      // Keep isHandlingClick true for an additional time to prevent double click
      // This creates a "cooldown period" where clicks are ignored
      setTimeout(() => {
        this.isHandlingClick = false;
      }, 300); // Additional wait time to prevent double click
    });
  }

  onConfirmCancelEvent(): Promise<void> {
    return new Promise(resolve => {
      const hasCancelPermission = this.$authorizationService.hasPermissionForAction(
        this.permissionEntityNameToUse || this.pluralEntityName,
        'cancel_booking',
      );

      const hasCancelOwnPermission = this.$authorizationService.hasPermissionForAction(
        this.permissionEntityNameToUse || this.pluralEntityName,
        'cancel',
        true,
      );

      const hasPublicCancelPermission = this.$authorizationService.hasPermissionForAction(
        this.permissionEntityNameToUse || this.pluralEntityName,
        'manage_public_bookings',
        true,
      );

      const hasPermissionToCancel =
        hasCancelPermission || hasCancelOwnPermission || hasPublicCancelPermission;

      if (hasPermissionToCancel) {
        const entityPath = this.$bpcApiRouteHelper.getEntityPath('booking-event');
        const basePath = this.isProfileView ? `${entityPath}/public` : `${entityPath}`;
        const relativePath = this.isProfileView ? 'cancel' : 'cancel/' + this.entity.id;
        const path = `${basePath}/${relativePath}`;

        const updateOrder = this.confirmUpdateOrderOptionSelected !== 'no_update';
        const refund = this.confirmUpdateOrderOptionSelected === 'update_and_refund';

        this.$bpcApi
          .post(path, {
            id: this.entity.id,
            cancelReason: this.cancelReasonOptionSelected,
            cancelReasonDescription: this.cancelReasonOptionDescriptionSelected,
            cancelOrders: updateOrder,
            refundOrders: refund,
            notify_by_email: this.notifyByEmailOptionSelected,
            actionForRepetitive: this.repetitiveActionOptionSelected,
          })
          .subscribe(
            () => {
              this.$emit('cancel-confirmed');
              this.closeModal();
              resolve();
            },
            () => {
              resolve();
            },
          );
      } else {
        this.$bvModal
          .msgBoxOk(
            this.$t(
              'global.modals.public_booking.cancellation.not_possible_by_permissions',
            ).toString(),
            {
              title: this.$t('global.modals.public_booking.cancellation.title').toString(),
              okTitle: this.$t('global.buttons.close').toString(),
            },
          )
          .then(() => resolve());
      }
    });
  }

  closeModal() {
    this.$bvModal.hide(this.modalId);
    this.$emit('close-modal');
  }

  onConfirmCancelEventCollection(): Promise<void> {
    return new Promise(resolve => {
      const basePath = this.$bpcApiRouteHelper.getEntityPath('booking-event');
      const path = this.isProfileView ? `${basePath}/public/cancel` : `${basePath}/cancel`;

      const updateOrder = this.confirmUpdateOrderOptionSelected !== 'no_update';

      this.$bpcApi
        .post(path, {
          bookingEvents: this.selectionBookingEvent,
          cancelOrders: updateOrder,
          cancelReason: this.cancelReasonOptionSelected,
          cancelReasonDescription: this.cancelReasonOptionDescriptionSelected,
          notify_by_email: this.notifyByEmailOptionSelected,
        })
        .subscribe(
          () => {
            this.closeModal();
            this.$emit('cancel-confirmed');
            resolve();
          },
          () => {
            this.closeModal();
            resolve();
          },
        );
    });
  }

  checkIfBookingCanBeCancelled(bookingEvent: BookingEvent): boolean {
    const diffInMinutes = moment(`${bookingEvent.date} ${bookingEvent.start_time}`).diff(
      moment(),
      'minutes',
    );
    const bookingOption = this.$authService.getIsIndividual()
      ? bookingEvent.booking_options
      : bookingEvent.booking_options_for_organization;
    return diffInMinutes >= 60 * (bookingOption?.fixed_options?.min_time_before_cancellation || 0);
  }

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.resetModal();
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
